import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import Grid from '@mui/material/Grid';
import StepLabel from '@mui/material/StepLabel';
import StepIcon from '@mui/material/StepIcon';
import StepConnector from '@mui/material/StepConnector';
import { STEP_LIST } from './../util/constants'
import { useTheme } from '@emotion/react';
import { styled } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';

const StyledStepIcon = styled(StepIcon)(({ theme }) => ({
    [`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
        height: '30px',
        width: '30px',
    },
    [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
        height: '20px',
        width: '20px',
    },
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
        height: '15px',
        width: '15px',
    },
    height: '40px',
    width: '40px',
    '&$completed': {
        color: theme.palette.success.main,
    },
    text: {
        fontSize: '12px',
        fontWeight: 300,
    },
    completed: {},
}));


function CustomStepper(props) {

    const { t } = useTranslation()
    const activeStep = useSelector(state => state.step)

    const theme = useTheme();
    // Theme
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));

    const styles = {
        stepperRoot: {
            width: '100%',
            backgroundColor: 'transparent',
            position: 'relative',
            [theme.breakpoints.down('sm')]: {
                textAlign: '-webkit-center',
            },

        },
        stepConnector: xsDown ? {
            top: 7,
            left: 'calc(-50% + 8px)',
            right: 'calc(50% + 8px)',
        } : smDown ? {
            top: 10,
            left: 'calc(-50% + 8px)',
            right: 'calc(50% + 8px)',
        } : mdDown ? {
            top: 15,
            left: 'calc(-50% + 15px)',
            right: 'calc(50% + 15px)',
        } : {
            top: 20,
            left: 'calc(-50% + 20px)',
            right: 'calc(50% + 20px)',
        },
        step_label_root: {
            [theme.breakpoints.down('sm')]: {
                fontSize: '12px',
                width: '40px',
            },

        },
        step_label_root2: {
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
            },

        },
        muistepHorizontal: {
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 1,
                paddingRight: 1,
            },
        },
    }

    // On mount
    useEffect(() => {

        return () => {
            // Clean up
        }
    }, [])

    return (
        <Grid>

            <Stepper
                connector={<StepConnector sx={styles.stepConnector} />}
                activeStep={activeStep}
                alternativeLabel
                sx={styles.stepperRoot}
                style={{ padding: "20px 0px 0px 0px" }}
                {...props}
            >
                {
                    STEP_LIST.map((label) => (
                        <Step sx={{ '& .MuiStepper-horizontal': styles.muistepHorizontal }} key={label}>
                            <StepLabel sx={{ '& .MuiStepper-horizontal': styles.step_label_root2, '& .MuiStepLabel-label': styles.step_label_root }} StepIconComponent={StyledStepIcon}>{t(label)}</StepLabel>
                        </Step>
                    ))

                }

            </Stepper>

        </Grid>
    )
}

export default CustomStepper
